var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "has-background-dark tile-border is-size-6" },
    [
      _vm.jobsOverDueToBeInvoiced && _vm.jobsToBeInvoiced
        ? _c(
            "DashboardPanel",
            [
              _c(
                "p",
                {
                  staticClass:
                    "panel-heading has-text-centered has-text-white custom-panel-heading",
                },
                [_vm._v("JOBS COMPLETED NOT INVOICED ")]
              ),
              _c("DashboardProgressBar", {
                attrs: {
                  "is-loading": _vm.isLoading,
                  "initial-color": "#F9BD44",
                  "loading-color": "#967a09",
                },
              }),
              _c("div", { staticClass: "p-5" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "container column-border has-background-black mb-5",
                    class: { "clickable-panel": _vm.hasPermissions },
                    on: {
                      click: function ($event) {
                        return _vm.handleQuoteRedirect(0)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "columns" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "column is-two-fifths is-flex is-align-items-center",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "column is-2 is-flex is-align-items-center is-justify-content-center jobs-to-be-invoiced is-bold is-size-5",
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.jobsToBeInvoiced.length) + " "
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "pl-5" }, [
                            _vm._v("Jobs To Be Invoiced"),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "column is-two-fifths is-flex is-justify-content-space-between is-align-items-center",
                        },
                        [
                          _c("div", [_vm._v("Total Amount Not Invoiced")]),
                          _c("div", {
                            staticClass: "is-divider-vertical px-4",
                          }),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "column is-flex is-one-fifth is-align-items-center pl-0",
                        },
                        [
                          _c("div", { staticClass: "jobs-value" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "jobs-to-be-invoiced-value-text is-size-5",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.getCreditAmountList(
                                      _vm.jobsToBeInvoiced
                                    )[0]
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "jobs-to-be-invoiced-cents-text is-size-6",
                              },
                              [
                                _vm._v(
                                  "." +
                                    _vm._s(
                                      _vm.getCreditAmountList(
                                        _vm.jobsToBeInvoiced
                                      )[1]
                                    )
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "container column-border has-background-black",
                    class: { "clickable-panel": _vm.hasPermissions },
                    on: {
                      click: function ($event) {
                        return _vm.handleQuoteRedirect(2)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "columns" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "column is-two-fifths is-flex is-align-items-center",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "column is-2 is-flex is-align-items-center is-justify-content-center jobs-to-be-invoiced is-bold is-size-5",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.jobsNotInvoicedAfterEndDate.length
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "pl-5" }, [
                            _vm._v("Jobs Past Due Date"),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "column is-flex is-two-fifths is-justify-content-space-between is-align-items-center",
                        },
                        [
                          _c("div", [_vm._v("Yet To Be Invoiced")]),
                          _c("div", {
                            staticClass: "is-divider-vertical px-4",
                          }),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "column is-flex is-one-fifth is-align-items-center pl-0",
                        },
                        [
                          _c("div", { staticClass: "jobs-value" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "jobs-to-be-invoiced-value-text is-size-5",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.getCreditAmountList(
                                      _vm.jobsNotInvoicedAfterEndDate
                                    )[0]
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "jobs-to-be-invoiced-cents-text is-size-6",
                              },
                              [
                                _vm._v(
                                  "." +
                                    _vm._s(
                                      _vm.getCreditAmountList(
                                        _vm.jobsNotInvoicedAfterEndDate
                                      )[1]
                                    )
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }